import { FC } from 'react'

export const HamburgerIcon: FC = () => {
  return (
    <svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1.33325H25M1 7.99992H25M1 14.6666H25" stroke="#00112F" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}
